import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tag, Euro, Clock, Disc, Inbox } from "lucide-react";
import api from "../../lib/api";
import SEO from "../../components/site/SEO";

const TUILES = [
  { to: "/admin/promotions", label: "Promotions", icone: Tag, aide: "Créer ou arrêter une promotion" },
  { to: "/admin/tarifs", label: "Tarifs", icone: Euro, aide: "Modifier les prix affichés" },
  { to: "/admin/horaires", label: "Horaires", icone: Clock, aide: "Horaires et fermetures exceptionnelles" },
  { to: "/admin/catalogue", label: "Catalogue", icone: Disc, aide: "Ajouter ou retirer des pneus" },
];

export default function AdminDashboard() {
  const [nouvelles, setNouvelles] = useState(null);

  useEffect(() => {
    api.get("/admin/demandes/compteur").then((res) => setNouvelles(res.data.nouvelles)).catch(() => {});
  }, []);

  return (
    <>
      <SEO title="Tableau de bord — Espace gérant | Promo Pneus" description="Tableau de bord de l'espace gérant Promo Pneus." />
      <h1 className="font-heading font-bold uppercase text-4xl text-brand-dark tracking-tight mb-2" data-testid="admin-dashboard-titre">
        Bonjour.
      </h1>
      <p className="text-brand-body text-lg mb-8">Que souhaitez-vous faire ?</p>

      <Link to="/admin/demandes" data-testid="dashboard-demandes-compteur"
        className="mb-8 flex items-center gap-4 bg-white border-l-4 border-brand-red p-6 shadow-sm hover:shadow-md transition-shadow">
        <Inbox size={32} className="text-brand-red shrink-0" aria-hidden="true" />
        <span className="font-heading font-semibold uppercase tracking-wide text-2xl text-brand-dark">
          {nouvelles === null
            ? "Chargement des demandes…"
            : nouvelles === 0
              ? "Aucune nouvelle demande"
              : `${nouvelles} nouvelle${nouvelles > 1 ? "s" : ""} demande${nouvelles > 1 ? "s" : ""} à traiter`}
        </span>
      </Link>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {TUILES.map((t) => (
          <Link key={t.to} to={t.to} data-testid={`tuile-${t.label.toLowerCase()}`}
            className="bg-white p-8 shadow-sm border-l-4 border-brand-red hover:shadow-md transition-shadow group">
            <t.icone size={36} className="text-brand-red mb-4" aria-hidden="true" />
            <h2 className="font-heading font-semibold uppercase text-3xl text-brand-dark group-hover:text-brand-red transition-colors">
              {t.label}
            </h2>
            <p className="text-brand-body mt-1">{t.aide}</p>
          </Link>
        ))}
      </div>
    </>
  );
}
